
import { Box, Divider, Card, InputLabel, Select, CardActions, CardMedia, Stack, FormControl, RadioGroup, Radio, Grid, Typography, Tooltip, IconButton, Autocomplete, TextField, InputAdornment, Tabs, useTheme, AppBar, FormGroup, FormControlLabel, Checkbox, Button, Toolbar, Menu, MenuItem } from "@mui/material";

import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';

import React, { useState, useEffect, useRef } from "react";
import PhoneIcon from '@mui/icons-material/Phone';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import Email from '@mui/icons-material/EmailOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import AddIcon from '@mui/icons-material/Add';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import CallAlertBar from "../../../Layout/Alertbar";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import Addicon1 from '@mui/icons-material/AddCircle';
// import NewDesignationDialog from "../../Master/AddMasters/AddDesignation";
import EmployeeActionMenu from "./ActionMenu";
import ExitEmployee from "./ExitEmployee";
import EmployeeCompensation from "./Compansation";
import EmployeeSkillEditor from "./SkillEditor";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import NewDesignationDialog from "../../master/AddDesignation";
import FileUploadWithPreview from "../../../components/FileUploadWithPreview";
import useSelectedOption from "../../../components/useSelectedOption";
import SkillTable from "./SkillTable";

import EmployeeAccidentSection from "../employeeAccidentAndMedicalCondition/EmployeeAccidentSection";
import EmployeeMedicalConditionSection from "../employeeAccidentAndMedicalCondition/EmployeeMedicalConditionSection";
import EmployeeEquipmentForm from "./EmployeeEquipmentForm";
import { useReportingManagers } from "../../../hooks/useReportingManagers";
import useFetchCountryList from "../../../hooks/useCountryList";
import usePartyTypeList from "../../../hooks/usePartyTypeList";
import useDesignationList from "../../../hooks/useDesignationList";
import useEmployeeStatusList from "../../../hooks/useEmployeeStatusList";
import useBloodGroupList from "../../../hooks/useBloodGroupList";
import useJobLevelList from "../../../hooks/useJobLevelList";
import useGetEmployeeCode from "../../../hooks/useGetEmployeeCode";
import useCountryList from "../../../hooks/useCountryList";
import useStateList from "../../../hooks/useStateList";
import useCityList from "../../../hooks/useCityList";
import BankDetailsForm from "../../common/BankDetails";
import useBankAccountType from "../../../hooks/useBankAccountType";
import useDepartment from "../../../hooks/useDepartment";


function TabPanel(props) {

    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}




const AddNewEmployee = ({ handlecallback, editPartyID }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [value, setValue] = React.useState(0);


    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const handleMessage = (serverityval, msg, title) => {
        // Update state with error message        
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);

    };

    // const callError = (serverityval, msg, title) => {
    //     // Update state with error message        
    //     setParentRollSeverityvalue(serverityval);
    //     setParentRollMessageValue(msg);
    //     setParentRollAlertTitleValue(title);
    //     setParentRollMsgOpen(true);
    // };



    // multiple selection options  


    const [currentCountry, setCurrentCountry] = useState([]);
    const [currentCountryID, setCurrentCountryID] = useState([]);

    const [selectedCurrentCountry, setSelectedCurrentCountry] = useState(null);
    const [isCountryLoaded, setIsCountryLoaded] = useState(false);
    const [currentState, setCurrentState] = useState([]);
    const [currentStateID, setCurrentStateID] = useState([]);
    const [selectedCurrentState, setSelectedCurrentState] = useState(null);
    const [currentCity, setCurrentCity] = useState([]);
    const [currentCityID, setCurrentCityID] = useState([]);
    const [selectedCurrentCity, setSelectedCurrentCity] = useState(null);
    const [parmanentCountry, setParmanentCountry] = useState([]);
    const [parmanentCountryID, setParmanentCountryID] = useState([]);
    const [selectedParmanentCountry, setSelectedParmanentCountry] = useState(null);
    const [isBillingCountryLoaded, setIsBillingCountryLoaded] = useState(false);



    const [parmanentStateID, setParmanentStateID] = useState([]);
    const [selectedParmanentState, setSelectedParmanentState] = useState(null);


    const [parmanentCityID, setParmanentCityID] = useState([]);
    const [selectedParmanentCity, setSelectedParmanentCity] = useState(null);

    // billing fields
    const [currentAddressLine1, setCurrentAddressLine1] = useState('');
    const [pincode, setPincode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [faxNumber, setFaxNumber] = useState('');

    const [parmanentAddressLine1, setPaemanentAddressLine1] = useState('');
    const [parmanentPincode, setParmanentPincode] = useState('');
    const [parmanentPhoneNumber, setParmanentPhoneNumber] = useState('');
    const [paramanentfaxNumber, setParamanentFaxNumber] = useState('');
    const salutationOptions = [
        { Description: 'Mr' },
        { Description: 'Mrs' },
        { Description: 'Ms' },
        { Description: 'Miss' },
        { Description: 'Dr' }
    ];

    // details
    const [salutation, setSalutation] = useState(
        salutationOptions.find(o => o.Description === 'Mr')
    );
    const [selectedSalutation, setSelectedSalutation] = useState('Mr');


    const [firstName, setFirstName] = useState('');
    const [secondName, setSecondName] = useState('');


    const [employeeEmail, setEmployeeEmail] = useState('');
    const [employeeWorkPhone, setEmployeeWorkPhone] = useState('');
    const [employeeMobile, setEmployeeMobile] = useState('');
    const [employeeEmergencyContact, setEmployeeEmergencyContact] = useState('');
    const [employeeAadhar_Number, setEmployeeAdhar_Number] = useState('');
    const [employeePAN_Number, setEmployeePAN_Number] = useState('');
    const [employeeUAN_Number, setEmployeeUAN_Number] = useState('');
    const [managerStatus, setManagerStatus] = useState(false);
    const [maritalStatus, setMaritalStatus] = useState(false);

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    const isPanValid = panRegex.test(employeePAN_Number) || employeePAN_Number === '';

    // UAN must be exactly 12 digits
    const uanRegex = /^[0-9]{12}$/;
    const isUANValid = uanRegex.test(employeeUAN_Number) || employeeUAN_Number === '';

    const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState(dayjs());
    const [dateOfJoinning, setDateOfJoinning] = useState(dayjs());
    const [dateOfLeaving, setDateOfLeaving] = useState(dayjs());
    const [incrementMonth, setIncrmentMonth] = useState(dayjs());

    const [selectedValue, setSelectedValue] = useState('male');
    const [openDialog_department, setopenDialog_department] = useState(false);

    const [image, setImage] = useState(null);
    const [panFileBase64, setPanFileBase64] = useState(null);
    const [panFileName, setPanFileName] = useState('');

    const [aadharFileBase64, setAadharFileBase64] = useState(null);
    const [aadharFileName, setAadharFileName] = useState('');

    const [uanFileBase64, setUanFileBase64] = useState(null);
    const [uanFileName, setUanFileName] = useState('');

    const [employee, setEmployee] = useState('');
    //const [employeelist, setEmployeelist] = useState([]);
    const [employeeID, setEmployeeID] = useState("");

    const [ReportingManagerDesignation, setReportingManagerDesignation] = useState("");
    const [ReportingManagerJobLevel, setReportingManagerJobLevel] = useState("");
    const [dataSkillDetails, setDataSkillDetails] = useState([]);

    const [currentStatus, setCurrentStatus] = useState("present");
    const [accidentDetails, setAccidentDetails] = useState([
        {
            accidentDate: '',
            accidentTime: '',
            location: '',
            description: '',
            cause: '',
            injuryType: '',
            severity: '',
            reportedBy: '',
            actionTaken: '',
            remarks: ''
        }
    ]);

    const [medicalConditions, setMedicalConditions] = useState([
        {
            conditionName: '',
            diagnosisDate: '',
            treatment_details: '',
            conditionType: '',
            current_status: '',
            treatingDoctor: '',
            hospitalName: '',
            remarks: ''
        }
    ]);

    const [formData, setFormData] = useState({
        quartersNumber: '',
        facilitiesAvailable: [],
        vehicleNumber: '',
        vehicleType: '',
        rcFile: null,
        rcFileName: '',
        facilityType: '',
    });

    const [equipmentList, setEquipmentList] = useState([
        {
            equipment_name: '',
            brand: '',
            model: '',
            serial_number: '',
            issued_date: null,
            return_date: null,
            charger_included: false,
            bag_included: false,
            mouse_included: false,
            stylus_provided: false,
            bluetooth_headset: false,
            remarks: ''
        }
    ]);


    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [enableRejectParentRoll, setEnableRejectParentRoll] = useState(false);
    const [newEmployee, setNewEmployee] = useState(true);
    const [exitEmployee, setExitEmployee] = useState(false);
    const [employeeCompansation, setEmployeeCompansation] = useState(false);


    const [isLoadEditParty, setLoadEditParty] = useState(false);
    const [selectemployeeid, setSelectedemployeeid] = useState(0);

    const [showPassword, setShowPassword] = useState(false);
    const [accountMismatch, setAccountMismatch] = useState(false);

    const [isModalAccountOpen, setIsModalAccountOpen] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };


    const handleMouseDownPassword = (event) => {
        event.preventDefault(); // Prevents focusing on the button when clicked
    };

    const handleOpenModal = () => {
        setIsModalAccountOpen(true);
    };


    // hooks call 
    const { department, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID, } = useDepartment(0)
    const { jobLevel, selectedJobLevel, jobLevelID, setSelectedJobLevel, setJobLevelID, loadJobLevelByID, } = useJobLevelList(0);
    const { employeelist, loading, error } = useReportingManagers(selectedDepartmentID, jobLevelID);
    const { employeeNumber, setEmployeeNumber } = useGetEmployeeCode(editPartyID);
    const { bankAccounts, selectedBankAccounts, selectedBankAccountID, setSelectedBankAccounts, setSelectedBankAccountID, loadBankAccountByID, } = useBankAccountType(0);

    //designation 
    const { designation, selectedDesignation, designationID, setDesignation, setSelectedDesignation, setDesignationID, loadDesignationByID } = useDesignationList({ editID: 0, handleMessage });
    const { employeeStatus, selectedEmployeeStatus, employeeStatusID, setEmployeeStatus, setSelectedEmployeeStatus, setEmployeeStatusID, loadEmployeeStatusByID, } = useEmployeeStatusList({ editID: 0, handleMessage });
    const { bloodGroup, selectedBloodGroup, bloodGroupID, setBloodGroup, setSelectedBloodGroup, setBloodGroupID, loadBloodGroupByID, } = useBloodGroupList({ editID: 0, handleMessage });


    // Location   
    useFetchCountryList(isCountryLoaded, setCurrentCountry, handleMessage, setIsCountryLoaded);
    useFetchCountryList(isBillingCountryLoaded, setParmanentCountry, handleMessage, setIsCountryLoaded);
    const currentCountryByHook = useCountryList(0);
    const permenantCountryByHook = useCountryList(0);
    const currentStateByHook = useStateList(0);
    const permenantStateByHook = useStateList(0);
    const currentCityByHook = useCityList(0);
    const permenantCityByHook = useCityList(0);

    const handleEmployeeChange = (event, value) => {
        if (value) {
            setEmployee(value);
            setEmployeeID(value.id);
            setReportingManagerDesignation(value.current_designation);
            setReportingManagerJobLevel(value.job_level);
        }
        else {
            setEmployee('');
            setEmployeeID('');
            setReportingManagerDesignation('');
            setReportingManagerJobLevel('');
        }
    }


    // Example download handler that triggers a download of the file
    const handleDownload = (base64Data, fileName) => {
        if (!base64Data) return;

        const link = document.createElement('a');
        link.href = `data:application/octet-stream;base64,${base64Data}`;
        link.download = fileName || 'downloaded_file';
        link.click();

    };

    const handlePanFileChange = ({ base64, fileName }) => {
        setPanFileBase64(base64);
        setPanFileName(fileName);
    };

    const handleAadharFileChange = ({ base64, fileName }) => {
        setAadharFileBase64(base64);
        setAadharFileName(fileName);
    };

    const handleUANFileChange = ({ base64, fileName }) => {
        setUanFileBase64(base64);
        setUanFileName(fileName);
    };


    const handleDeliveryAddressChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };


    const callback = () => {
        handlecallback();
    }

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });

    const [bankDetails, setBankDetails] = useState([{
        accountHolderName: '',
        bankName: '',
        accountNumber: '',
        reEnterAccountNumber: '',
        ifsc: '',
        accountTypeId: '',
        branchName: '',
        bankAddress: '',
        contactNumber: '',
        cancelledCheque: null,
        cancelledCheque_file_name: '',
        rtgsDetail: null,
        rtgsDetail_file_name: '',
        bankLetter: null,
        bankLetter_file_name: '',
        id_document: 0,
        document_type: '',
        bank_id_val: 0,
    }]);


    const handleInputChange = (index, e) => {
        const { name, value } = e.target;
        const newBankDetails = [...bankDetails];
        newBankDetails[index][name] = value;
        setBankDetails(newBankDetails);
    };

    const handleAutocompleteChange = (index, field, value) => {
        const updatedDetails = [...bankDetails];
        updatedDetails[index][field] = value;
        setBankDetails(updatedDetails);
    };


    const handleBankLetterInputChange = (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const newBankDetails = [...bankDetails];
        newBankDetails[index]['bankLetter'] = file;
        newBankDetails[index]['bankLetter_file_name'] = file.name;
        setBankDetails(newBankDetails);
    };

    const handleChequeInputChange = (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const newBankDetails = [...bankDetails];
        newBankDetails[index]['cancelledCheque'] = file;
        newBankDetails[index]['cancelledCheque_file_name'] = file.name;
        setBankDetails(newBankDetails);
    };

    const handleRTGSInputChange = (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const newBankDetails = [...bankDetails];
        newBankDetails[index]['rtgsDetail'] = file;
        newBankDetails[index]['rtgsDetail_file_name'] = file.name;
        setBankDetails(newBankDetails);
    };

    const handleDownloadBankLetter = (index, e, docType) => {
        try {

            const bank = [...bankDetails];

            let rawData = null;
            let fileName = '';

            if (docType === 'bank_letter') {
                rawData = bank[index]?.bankLetter;
                fileName = bank[index]?.bankLetter_file_name || 'bank_letter.pdf';
            }
            else if (docType === 'rtgs') {
                rawData = bank[index]?.rtgsDetail;
                fileName = bank[index]?.rtgsDetail_file_name || 'rtgs.pdf';
            }
            else if (docType === 'cancel_cheque') {
                rawData = bank[index]?.cancelledCheque;
                fileName = bank[index]?.cancelledCheque_file_name || 'cancelled_cheque.pdf';
            }

            if (!rawData) {
                alert("No file found.");
                return;
            }

            let byteArray;

            if (rawData.startsWith('\\x')) {
                // Hex format (\xNN\xNN...)
                const hexString = rawData.replace(/\\x/g, '');
                const hexPairs = hexString.match(/.{1,2}/g); // Split into byte pairs
                if (!hexPairs) throw new Error("Invalid hex format");

                const byteNumbers = hexPairs.map(h => parseInt(h, 16));
                byteArray = new Uint8Array(byteNumbers);
            } else {
                // Assume it's base64
                try {
                    const byteCharacters = atob(rawData);
                    const byteNumbers = new Array(byteCharacters.length)
                        .fill()
                        .map((_, i) => byteCharacters.charCodeAt(i));
                    byteArray = new Uint8Array(byteNumbers);
                } catch (base64Err) {
                    throw new Error("Invalid base64 format");
                }
            }

            // Download logic
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Clean up
        } catch (error) {
            console.error("Download error:", error);
            alert("An error occurred while downloading the file.");
        }
    };


    const addBankDetail = () => {
        if (accountMismatch) {
            alert("Fix account number mismatch before continuing");
            return; // 🚫 stops further processing
        }


        setBankDetails([...bankDetails, {
            accountHolderName: '',
            bankName: '',
            accountNumber: '',
            reEnterAccountNumber: '',
            ifsc: '',
            accountTypeId: '',
            branchName: '',
            bankAddress: '',
            contactNumber: '',
            cancelledCheque: null,
            cancelledCheque_file_name: '',
            rtgsDetail: null,
            rtgsDetail_file_name: '',
            bankLetter: null,
            bankLetter_file_name: '',
            id_document: 0,
            document_type: '',
            bank_id_val: 0,
        }]);
    };

    const removeBankDetail = (index) => {
        const newBankDetails = bankDetails.filter((_, i) => i !== index);
        setBankDetails(newBankDetails);
    };



    // Small helper to set selected entity + its ID safely
    const setSelection = (hook, kind, value) => {
        if (!value || !hook) return;
        hook[`setSelected${kind}`]?.(value);
        hook[`setSelected${kind}ID`]?.(value.id);
    };

    // COUNTRY
    const handleCountryChange = (event, value) => {
        setSelection(currentCountryByHook, "Country", value);
        currentStateByHook?.loadStateByCountryID?.(currentStateID ?? 0, value?.id);
    };

    const handleBillingCountryChange = (event, value) => {
        setSelection(permenantCountryByHook, "Country", value);
        permenantStateByHook?.loadStateByCountryID?.(parmanentStateID ?? 0, value?.id);
    };

    // STATE
    const handleStateChange = (event, value) => {
        setSelection(currentStateByHook, "State", value);
        currentCityByHook?.loadCityByStateID?.(0, value?.id);
    };

    const handleBillingStateChange = (event, value) => {
        setSelection(permenantStateByHook, "State", value);
        permenantCityByHook?.loadCityByStateID?.(0, value?.id);
    };

    // CITY (added)
    const handleCityChange = (event, value) => {
        setSelection(currentCityByHook, "City", value);
    };

    const handleBillingCityChange = (event, value) => {
        setSelection(permenantCityByHook, "City", value);
    };

    const handleCopyBillingToShipping = () => {

        const confirm = window.confirm(`Are you sure you want to copy the billing address to the shipping address?`);

        if (!confirm) {
            return;
        }
        setPaemanentAddressLine1(currentAddressLine1);
        setParmanentPincode(pincode);
        setParmanentPhoneNumber(phoneNumber);
        setParamanentFaxNumber(faxNumber);
        permenantCountryByHook.loadCountryByID(currentCountryByHook.selectedCountryID);
        permenantStateByHook.loadStateByCountryID(currentStateByHook.selectedStateID, currentCountryByHook.selectedCountryID);
        permenantCityByHook.loadCityByStateID(currentCityByHook.selectedCityID, currentStateByHook.selectedStateID);
    };



    const handleSalutationChange = (event, value) => {
        setSalutation(value);
        setSelectedSalutation(value ? value.Description : '');
    };

    const validateForm = () => {
        const errors = {};

        if (!employeeNumber) errors.employeeNumber = "required field.";
        if (!firstName) errors.firstName = "required field.";
        if (!secondName) errors.secondName = "required field.";

        if (!employeeEmail) errors.email = "required field.";
        else if (!/\S+@\S+\.\S+/.test(employeeEmail)) errors.email = "required field.";


        const workPhone = employeeWorkPhone?.trim();

        if (workPhone && !/^\d{10}$/.test(workPhone)) {
            errors.employeeWorkPhone = "required field.";
        }

        if (!employeeMobile) errors.mobile = "required field.";
        else if (!/^\d{10}$/.test(employeeMobile)) errors.mobile = "Mobile number must be 10 digits.";

        if (!designationID) errors.designation = "required field.";
        if (!selectedDepartmentID) errors.department = "required field.";

        if (!selectedEmployeeStatus) errors.selectedEmployeeStatus = "required field.";


        // Add more as per your form fields...

        return errors;
    };

    const [formErrors, setFormErrors] = useState({});


    const validateEachField = () => {
        const missingFields = [];

        if (!employeeNumber) missingFields.push("Employee Number");
        if (!firstName) missingFields.push("First Name");
        if (!secondName) missingFields.push("Second Name");
        if (!selectedDepartmentID) missingFields.push("Department");
        if (!designationID) missingFields.push("Designation");

        if (!selectedEmployeeStatus) missingFields.push("Employee Status");


        if (!employeeEmail) missingFields.push("Email");
        else if (!/\S+@\S+\.\S+/.test(employeeEmail)) missingFields.push("Email (Invalid Format)");

        const workPhone = employeeWorkPhone?.trim();

        if (workPhone && !/^\d{10}$/.test(workPhone)) {
            missingFields.push("Work Phone (Must be 10 digits)");
        }


        if (!employeeMobile) missingFields.push("Mobile Number");
        else if (!/^\d{10}$/.test(employeeMobile)) missingFields.push("Mobile Number (Must be 10 digits)");



        return missingFields;
    };

    const handleSubmit = () => {
        //event
        // event.preventDefault();

        const missingFields = validateEachField();



        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors); // set errors to show in UI
        }


        if (missingFields && missingFields.length > 0) {
            const formattedMessage = `Please fill the following fields:\n${missingFields.map(f => `${f}`).join(',\n')}`;

            handleMessage('error', formattedMessage, 'Missing Fields');

            return;
        }


        let pkey_mode = 0;
        let u_partyID = 0;

        if (editPartyID != 0) {
            pkey_mode = 1;
            u_partyID = editPartyID;
        }

        const payload = {
            p_companyid: localStorage.getItem('companyid'),
            p_employee_code: employeeNumber,
            p_employee_id: editPartyID,
            p_salutation: selectedSalutation,
            p_first_name: firstName,
            p_second_name: secondName,
            p_gender: selectedValue,
            p_dob: dateOfBirth,
            p_doj: dateOfJoinning,
            p_dol: dateOfLeaving,
            p_designation_id: designationID,
            p_email: employeeEmail,
            p_work_phone: employeeWorkPhone,
            p_mobile_number: employeeMobile,
            p_emp_status_id: employeeStatusID,
            p_aadhar_number: employeeAadhar_Number,
            p_pan_number: employeePAN_Number,
            p_uan_number: employeeUAN_Number,
            p_blood_group_id: bloodGroupID,
            p_marital_status: maritalStatus,
            p_manager_status: managerStatus,
            p_job_level_id: jobLevelID,

            // current address
            p_current_addressline1: currentAddressLine1,
            p_current_country: currentCountryByHook.selectedCountryID,
            p_current_state: currentStateByHook.selectedStateID,
            p_current_city: currentCityByHook.selectedCityID,
            p_current_pincode: pincode,
            p_current_phone: phoneNumber,
            p_current_faxnumber: faxNumber,

            // parmanent address
            p_parmanent_addressline1: parmanentAddressLine1,
            p_parmanent_country: permenantCountryByHook.selectedCountryID,
            p_parmanent_state: permenantStateByHook.selectedStateID,
            p_parmanent_city: permenantCityByHook.selectedCityID,
            p_parmanent_pincode: parmanentPincode,
            p_parmanent_phone: parmanentPhoneNumber,
            p_parmanent_faxnumber: paramanentfaxNumber,

            // bank details
            p_employee_bank_details: bankDetails,
            p_mode: pkey_mode,
            p_employee_image: productimageBase64,
            p_department_id: selectedDepartmentID,

            p_panfile: panFileBase64,
            p_aadharfile: aadharFileBase64,
            p_uanfile: uanFileBase64,
            p_panfile_filename: panFileName ? panFileName : '',
            p_aadharfile_filename: aadharFileName ? aadharFileName : '',
            p_uanfile_filename: uanFileName ? uanFileName : '',
            p_id_reporting_manager: employeeID,
            // skill details
            p_skills: dataSkillDetails,

            // employee accident and medical condition detail
            p_accident_list: accidentDetails,
            p_medical_condition: medicalConditions,
            p_user: localStorage.getItem('userID'),
            p_plant_id: 1,
            p_quarters_number: formData.quartersNumber,
            p_facilities_available: formData.facilitiesAvailable, // Array
            p_vehicle_number: formData.vehicleNumber,
            p_vehicle_type: formData.vehicleType,
            p_rc_file_base64: formData.rcFile,
            p_rc_file_name: formData.rcFileName,
            p_facilityType: formData.facilityType,

            // equipment details
            p_equipment_list: equipmentList,
            p_emergency_phone_number: employeeEmergencyContact,
            p_increment_month: incrementMonth,
        };

        callApi(API_ENDPOINTS.HR_CRUD_EMPLOYEE_DETAILS, 'POST', { 'Content-Type': 'application/json' }, payload)
            .then(data => {
                if (data && data.length > 0) {
                    let msg = editPartyID != 0 ? 'Employee Data Updated Successfully' : 'New Employee Added Successfully';
                    handleMessage('info', msg, 'Info');
                }
            })
            .catch(error => {
                // Update state with error message        
                handleMessage('error', error.message, 'Error');
            });

    };


    useEffect(() => {
        if (isLoadEditParty) return;
        if (!editPartyID) return;

        const companyId = localStorage.getItem('companyid');
        if (!companyId) return;

        const parseJSONSafe = (value, fallback) => {
            if (value == null) return fallback;
            try {
                return typeof value === 'string' ? JSON.parse(value) : value;
            } catch (e) {
                console.error('JSON parse error:', e);
                return fallback;
            }
        };

        const cleanBase64 = (s) => (typeof s === 'string' ? s.replace(/\s/g, '') : '');

        const loadEmployeeDetail = async () => {
            setUpdateProgress(true);
            try {
                const para = { p_companyid: companyId, p_employeeid: editPartyID };
                const data = await callApi(
                    API_ENDPOINTS.HR_EDIT_EMPLOYEE_DETAILS,
                    'POST',
                    { 'Content-Type': 'application/json' },
                    para
                );

                if (!Array.isArray(data) || data.length === 0) {
                    setCurrentState([]);
                    setCurrentCity([]);
                    return;
                }

                const row = data[0] ?? {};

                // Salutation
                const fetchedSalutation = row.first_name ?? '';
                setSelectedSalutation(fetchedSalutation);
                const matchingOption = salutationOptions.find(
                    (o) => o.Description === fetchedSalutation
                );
                setEmployeeNumber(row.employee_code ?? '');
                setSalutation(matchingOption ?? null);

                // Basic info
                setFirstName(row.middle_name ?? '');
                setSecondName(row.last_name ?? '');
                setDateOfBirth(row.date_of_birth ?? null);
                setDateOfJoinning(row.date_of_joining ?? null);
                setDateOfLeaving(row.date_of_leaving ?? null);

                // Lookup-driven loads
                if (row.designation_id) loadDesignationByID(row.designation_id);
                if (row.blood_group_id) loadBloodGroupByID(row.blood_group_id);
                if (row.job_level_id) loadJobLevelByID(row.job_level_id);
                if (row.department_id) loadDepartmentByID(row.department_id);
                if (row.employee_status_id) loadEmployeeStatusByID(row.employee_status_id);

                // Contact
                setEmployeeEmail(row.email ?? '');
                setEmployeeWorkPhone(row.work_phone ?? '');
                setEmployeeMobile(row.mobile ?? '');

                // IDs
                setEmployeeAdhar_Number(row.aadhar_number ?? '');
                setEmployeePAN_Number(row.pan_number ?? '');
                setEmployeeUAN_Number(row.uan ?? '');

                // Address - current
                setCurrentAddressLine1(row.current_address ?? '');
                if (row.current_country_id) currentCountryByHook.loadCountryByID(row.current_country_id);
                if (row.current_state_id && row.current_country_id) {
                    currentStateByHook.loadStateByCountryID(row.current_state_id, row.current_country_id);
                }
                if (row.current_city_id && row.current_state_id) {
                    currentCityByHook.loadCityByStateID(row.current_city_id, row.current_state_id);
                }
                setCurrentStateID(row.current_state_id ?? null);
                setCurrentCityID(row.current_city_id ?? null);
                setPincode(row.current_pincode ?? '');
                setPhoneNumber(row.current_phone ?? '');

                // Address - permanent
                setPaemanentAddressLine1(row.parmanent_address ?? '');
                if (row.parmanent_country_id) permenantCountryByHook.loadCountryByID(row.parmanent_country_id);
                if (row.parmanent_state_id && row.parmanent_country_id) {
                    permenantStateByHook.loadStateByCountryID(row.parmanent_state_id, row.parmanent_country_id);
                }
                if (row.parmanent_city_id && row.parmanent_state_id) {
                    permenantCityByHook.loadCityByStateID(row.parmanent_city_id, row.parmanent_state_id);
                }
                setParmanentPincode(row.parmanent_pincode ?? '');
                setParmanentPhoneNumber(row.parmanent_phone ?? '');

                // Statuses
                setManagerStatus(row.is_manager === 'true');
setMaritalStatus(row.marital_status === 'true');

            
                setIncrmentMonth(row.increment_month ?? '');
                setEmployeeEmergencyContact(row.emergency_phone_number ?? '');

                // Bank details
                const bankDetails = parseJSONSafe(row.bank_details, []);
                setBankDetails(Array.isArray(bankDetails) ? bankDetails : []);

                // Accident details
                const accidentDetails = parseJSONSafe(row.accident_details, []);
                setAccidentDetails(Array.isArray(accidentDetails) ? accidentDetails : []);

                // Medical condition details
                const medicalConditionDetails = parseJSONSafe(row.medical_condition_details, []);
                setMedicalConditions(Array.isArray(medicalConditionDetails) ? medicalConditionDetails : []);

                // Quarters/vehicle form data
                const parsedDetails = parseJSONSafe(row.quarters_vechile_detail, null);
                if (parsedDetails && typeof parsedDetails === 'object') {
                    setFormData({
                        quartersNumber: parsedDetails.quartersNumber ?? '',
                        facilitiesAvailable: parsedDetails.facilitiesAvailable ?? [],
                        vehicleNumber: parsedDetails.vehicleNumber ?? '',
                        vehicleType: parsedDetails.vehicleType ?? '',
                        rcFile: null, // file is not stored in DB
                        rcFileName: parsedDetails.rcFileName ?? '',
                        facilityType: parsedDetails.facilityType ?? '',
                    });
                }

                // Equipment list
                const eqDetails = parseJSONSafe(row.equipment_detail, []);
                if (Array.isArray(eqDetails) && eqDetails.length > 0) {
                    setEquipmentList(
                        eqDetails.map((item) => ({
                            equipment_name: item.equipmentName ?? '',
                            brand: item.brand ?? '',
                            model: item.model ?? '',
                            serial_number: item.serialNumber ?? '',
                            issued_date: item.issuedDate ?? null,
                            return_date: item.returnDate ?? null,
                            charger_included: Boolean(item.chargerIncluded),
                            bag_included: Boolean(item.bagIncluded),
                            mouse_included: Boolean(item.mouseIncluded),
                            stylus_provided: Boolean(item.stylusProvided),
                            bluetooth_headset: Boolean(item.bluetoothHeadset),
                            remarks: item.remarks ?? '',
                        }))
                    );
                } else {
                    setEquipmentList([
                        {
                            equipment_name: '',
                            brand: '',
                            model: '',
                            serial_number: '',
                            issued_date: null,
                            return_date: null,
                            charger_included: false,
                            bag_included: false,
                            mouse_included: false,
                            stylus_provided: false,
                            bluetooth_headset: false,
                            remarks: '',
                        },
                    ]);
                }

                // Reporting manager
                setEmployeeID(row.id_reporting_manager ?? null);
                setSelectedemployeeid(editPartyID);

                if (row.department_id && row.job_level_id) {
                    const params = {
                        p_companyid: companyId,
                        p_department_id: row.department_id,
                        p_job_level_id: row.job_level_id,
                    };
                    const dataEmp = await callApi(
                        API_ENDPOINTS.EMPLOYEE_GetReportingManagersList,
                        'POST',
                        { 'Content-Type': 'application/json' },
                        params
                    );
                    if (Array.isArray(dataEmp) && dataEmp.length) {
                        const filteredEmployee = dataEmp.find(
                            (emp) => emp.id === row.id_reporting_manager
                        );
                        if (filteredEmployee) {
                            setEmployee(filteredEmployee);
                            setReportingManagerDesignation(filteredEmployee.current_designation ?? '');
                            setReportingManagerJobLevel(filteredEmployee.job_level ?? '');
                        }
                    }
                }

                // Images
                if (row.imagebase) {
                    const base64String = cleanBase64(row.imagebase);
                    try {
                        const binaryString = window.atob(base64String);
                        const byteArray = new Uint8Array(binaryString.length);
                        for (let i = 0; i < binaryString.length; i++) byteArray[i] = binaryString.charCodeAt(i);

                        setProductimageBase64(base64String);
                        setproductimage((prev) => ({
                            ...prev,
                            productimage: Array.from(byteArray),
                        }));
                        setImage(`data:image/png;base64,${base64String}`);
                    } catch (err) {
                        console.error('Invalid base64 string:', err);
                    }
                }

                if (row.aadharbase) {
                    const base64String = cleanBase64(row.aadharbase);
                    setAadharFileBase64(base64String);
                    setAadharFileName(row.aadhar_filename ?? '');
                }

                if (row.panbase) {
                    const base64String = cleanBase64(row.panbase);
                    setPanFileBase64(base64String);
                    setPanFileName(row.pan_filename ?? '');
                }

                if (row.uanbase) {
                    const base64String = cleanBase64(row.uanbase);
                    setUanFileBase64(base64String);
                    setUanFileName(row.uan_filename ?? '');
                }
            } catch (error) {
                handleMessage('error', error?.message ?? 'Unknown error', 'Error');
            } finally {
                setUpdateProgress(false);
            }
        };

        loadEmployeeDetail();
        // Include all reactive dependencies used inside
    }, [isLoadEditParty, editPartyID]);


    const fileInputRef = useRef(null);
    const [productimage, setproductimage] = useState('');
    const [productimageBase64, setProductimageBase64] = useState(null);

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null; // Reset the input value
            fileInputRef.current.click();
        }
    };


    const handleImageDelete = () => {
        setImage(null);
        setproductimage('');
        setProductimageBase64(null);
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const result = event.target.result;
                setImage(result);

                const base64String = result.split(',')[1];
                const binaryString = window.atob(base64String);
                const byteArray = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    byteArray[i] = binaryString.charCodeAt(i);
                }
                setProductimageBase64(base64String); // Store the base64 string

                setproductimage((prevState) => ({
                    ...prevState,
                    productimage: Array.from(byteArray), // Convert Uint8Array to regular array
                }));
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    const handleOpenDialog_Department = () => {
        setopenDialog_department(true);
    };

    const handleCloseDialog_Department = () => {
        setopenDialog_department(false);
    };

    const [newDesignation, setNewDesignation] = useState({
        DesignationCodeDesc: '',
        DesignationCodeStatus: 'A',
    });

    const handleClearFormForDesignation = () => {
        setNewDesignation({
            DesignationCodeDesc: '',
            DesignationCodeStatus: 'A',
        });
    };

    const handleInputChangeForDesignation = (event) => {
        const { name, value } = event.target;
        setNewDesignation(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleAddDepartment = () => {
        // Add your logic to save the new product group
        if (!newDesignation.DesignationCodeDesc) {
            // If either field is empty, do not proceed
            return;
        }

        const clsproductDet = {
            cls: newDesignation,
        };

        fetch(API_ENDPOINTS.MASTER_ADD_OR_UPDATE_DESIGNATION, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(clsproductDet)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to add product department');
                }
                return response.json();
            })
            .then(data => {
                // showError(data.returnmsg, 'success');
            })
            .catch(error => {
                // setAlertMessage('Unable to add product department..!');
                // setalertsevierity('error');
                // showSnackbar();
            }, []);


        handleCloseDialog_Department();
    };


    const handlecallProcess = (buttonName) => {
        if (buttonName === 'QRCode') {

            setNewEmployee(false);
            setExitEmployee(true);
            setEmployeeCompansation(false);
        }
        else if (buttonName == 'compansation') {
            setNewEmployee(false);
            setExitEmployee(false);
            setEmployeeCompansation(true);
        }

        else if (buttonName === 'save') {
            handleSubmit();
        }


    };

    const CallBackExitEmployee = () => {
        setNewEmployee(true);
        setExitEmployee(false);
        setEmployeeCompansation(false);
    }

    // current status indication 
    const getStatusStyles = (status) => {
        switch (status?.toLowerCase()) {
            case 'present':
                return { bgColor: '#4caf50', textColor: '#fff' }; // green
            case 'absent':
                return { bgColor: '#ff9800', textColor: '#000' }; // orange
            case 'leave':
                return { bgColor: '#ffeb3b', textColor: '#000' }; // yellow
            case 'resignation':
                return { bgColor: '#f44336', textColor: '#fff' }; // red
            default:
                return { bgColor: '#1c1c1c', textColor: '#f6c46b' }; // default golden theme
        }
    };

    const statusStyles = getStatusStyles(currentStatus);

    useEffect(() => {
        if (!editPartyID) {
            if (editPartyID === 0) {
                setUpdateProgress(false);
            }
        }

    }, [editPartyID])

    const [updateProgress, setUpdateProgress] = useState(true);


    // bank detail 
    useEffect(() => {
        if (!updateProgress) {
            bankDetails.forEach((bank, index) => {
                const ifsc = bank.ifsc?.trim();
                if (ifsc && ifsc.length === 11) {
                    fetch(`https://ifsc.razorpay.com/${ifsc}`)
                        .then(res => {
                            if (!res.ok) throw new Error("Invalid IFSC");
                            return res.json();
                        })
                        .then(data => {
                            const updated = [...bankDetails];
                            updated[index] = {
                                ...updated[index],
                                bankName: data.BANK,
                                branchName: data.BRANCH,
                                bankAddress: data.ADDRESS,
                                contactNumber: data.CONTACT?.replace(/^(\+91)/, '') // Removes +91 from start
                            };
                            setBankDetails(updated);
                        })
                        .catch(err => {
                            console.error(`IFSC fetch failed for index ${index}`, err);
                        });
                }
            });
        }

    }, [bankDetails.map(b => b.ifsc).join(',')]); // triggers when any IFSC changes


    return (<>
        <Box padding={0}>

            {newEmployee && (
                <>


                    <>
                        <EmployeeActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} enableRejectParentRoll={enableRejectParentRoll} title={editPartyID} callback={callback} saveButtonDisabled={saveButtonDisabled} />
                        <Divider />

                         <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  px: 1,
                                  py: 1
                                }}
                              >
                                <Typography variant="h6"  >
                                  <span style={{ color: 'red' }}>*</span> Mandatory fields
                                </Typography>
                              </Box>

                        
                    </>
                    


                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

                    <form onSubmit={handleSubmit}>

                        <Box
                            sx={{
                                // backgroundColor: colors.primary[700],
                                padding: "5px",
                                borderRadius: "10px",
                                maxHeight: {
                                    xs: '72vh', // Extra small devices (phones)
                                    sm: '72vh', // Small devices (tablets)
                                    md: '74vh', // Medium devices (small laptops)
                                    lg: '80vh', // Large devices (desktops)
                                    xl: '89vh', // Extra large devices (large desktops)
                                },
                                overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: colors.primary[400],
                                    borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: colors.blueAccent[600],
                                    borderRadius: '10px',
                                    '&:hover': {
                                        background: colors.blueAccent[800],
                                    },
                                },
                                '&::-webkit-scrollbar-corner': {
                                    background: colors.primary[700],
                                }
                            }}>

                            <Grid container  >

                                <Grid item xs={12} sm={12} md={12} lg={8} xl={6} mt={0}>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Employee # <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={3.8} lg={5} xl={5}>
                                                <TextField value={employeeNumber} fullWidth size="small" label="" required variant="outlined"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                <CustomTooltip
                                                                    title={
                                                                        <span>
                                                                            <b>click here to enable or disable auto generation of employee number.</b> <br />
                                                                        </span>}
                                                                >
                                                                    <SettingsIcon style={{ fontSize: "20px" }} />
                                                                </CustomTooltip>

                                                            </InputAdornment>
                                                        ),
                                                    }} />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">

                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    // endIcon={<ArrowForwardIosIcon sx={{ fontSize: 14 }} />}
                                                    sx={{
                                                        backgroundColor: statusStyles.bgColor,
                                                        color: statusStyles.textColor,
                                                        borderRadius: '999px',
                                                        textTransform: 'none',
                                                        fontWeight: 'bold',
                                                        // px: 2.5,
                                                        // py: 0.7,
                                                        fontSize: 10,
                                                        boxShadow: 'none',
                                                        '&:hover': {
                                                            backgroundColor: statusStyles.bgColor, // same on hover to keep it clean
                                                            boxShadow: 'none',
                                                        },
                                                    }}
                                                >
                                                    {currentStatus}
                                                </Button>
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Primary Contact
                                                    <CustomTooltip
                                                        title={
                                                            <span>
                                                                <b>The name your enter here will be for primary contact. you can continue to add multiple contact to add multiple contact persons from the detail page.</b> <br />
                                                            </span>}
                                                    >
                                                        <IconButton sx={{ marginLeft: "5px" }}>
                                                            <InfoOutlinedIcon sx={{ color: colors.redAccent[500], fontSize: "16px" }} />
                                                        </IconButton>
                                                    </CustomTooltip>
                                                </Typography>

                                            </Grid>

                                            <Grid item xs={12} sm={11} md={2} lg={2} xl={2}>

                                                <Autocomplete
                                                    size="small"
                                                    fullWidth
                                                    required
                                                    options={salutationOptions}
                                                    value={salutation}
                                                    getOptionLabel={(option) => option.Description || ''}
                                                    isOptionEqualToValue={(option, value) =>
                                                        option.Description === value?.Description
                                                    }
                                                    onChange={handleSalutationChange}
                                                    renderInput={(params) => (
                                                        <TextField color='secondary' {...params} label="Salutation" required />
                                                    )}
                                                />

                                                {/* <Autocomplete
                                                    size="small"
                                                    fullWidth
                                                    required

                                                    options={salutationOptions}
                                                    value={salutation}
                                                    getOptionLabel={(option) => option.Description || ''}
                                                    onChange={handleSalutationChange}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Salutation" required variant="outlined" />
                                                    )}
                                                /> */}
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2.3} lg={2.3} xl={2.3}>
                                                <TextField color='secondary' autoFocus value={firstName} onChange={(e) => setFirstName(e.target.value)} size="small" label="First Name"
                                                    required fullWidth variant="outlined"
                                                    error={!!formErrors.firstName}
                                                    helperText={formErrors.firstName}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={2.8} lg={2.3} xl={2}>
                                                <TextField color='secondary' value={secondName}
                                                    onChange={(e) => setSecondName(e.target.value)}
                                                    size="small" label="Second Name" required
                                                    fullWidth variant="outlined" error={!!formErrors.secondName}
                                                    helperText={formErrors.secondName} />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Date of Birth <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Stack spacing={2}>
                                                        <DatePicker
                                                            size="small"
                                                            id="Orderdate"
                                                            value={dateOfBirth ? dayjs(dateOfBirth) : null}
                                                            onChange={(date) => setDateOfBirth(date)}
                                                            slotProps={{ textField: { size: 'small' } }}
                                                            fullWidth
                                                            format="DD-MMM-YYYY"
                                                            className="customDatePicker"
                                                            maxDate={dayjs()}   // 🔥 blocks future dates
                                                        />

                                                    </Stack>
                                                </LocalizationProvider>
                                            </Grid>

                                        </Grid>
                                    </Grid>


                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left" >
                                                    Gender <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                                <FormControl component="fieldset" >
                                                    <RadioGroup row value={selectedValue} onChange={handleDeliveryAddressChange}>
                                                        <FormControlLabel
                                                            value="male"
                                                            control={<Radio size="small" color="secondary" />}
                                                            label="Male"
                                                        />
                                                        <FormControlLabel
                                                            value="female"
                                                            control={<Radio size="small" color="secondary" />}
                                                            label="Female"
                                                        />
                                                        <FormControlLabel
                                                            value="transgender"
                                                            control={<Radio size="small" color="secondary" />}
                                                            label="Others"
                                                        />

                                                    </RadioGroup>
                                                </FormControl>

                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Date of Joining <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Stack spacing={2}>
                                                        <DatePicker
                                                            size="small"
                                                            id="Orderdate"
                                                            value={dateOfJoinning ? dayjs(dateOfJoinning) : null}
                                                            onChange={(date) => setDateOfJoinning(date)}
                                                            slotProps={{ textField: { size: 'small' } }}
                                                            fullWidth
                                                            format="DD-MMM-YYYY"
                                                            className="customDatePicker"
                                                            maxDate={dayjs()}   // 🚫 future dates blocked
                                                        />

                                                    </Stack>
                                                </LocalizationProvider>
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    {/* <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Date Of Leaving
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Stack spacing={2}>
                                                        <DatePicker
                                                            size="small"
                                                            id="Orderdate"
                                                            value={dayjs(dateOfLeaving)}
                                                            onChange={(date) => setDateOfLeaving(date)}
                                                            slotProps={{ textField: { size: 'small' } }}
                                                            fullWidth
                                                            format="DD-MMM-YYYY"
                                                            className="customDatePicker"
                                                            renderInput={(props) => (
                                                                <TextField required {...props} />
                                                            )}
                                                        />
                                                    </Stack>
                                                </LocalizationProvider>
                                            </Grid>

                                        </Grid>
                                    </Grid> */}

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={3} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Department <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                                <Autocomplete
                                                    size="small"
                                                    fullWidth
                                                    value={selectedDepartment}
                                                    onChange={(event, newValue) => { setSelectedDepartment(newValue); setSelectedDepartmentID(newValue.id); }}
                                                    options={department}
                                                    getOptionLabel={(option) => option.description || ''}
                                                    renderInput={(params) => (
                                                        <TextField  color='secondary' {...params} label="" required variant="outlined" error={!!formErrors.department}
                                                            helperText={formErrors.department} />
                                                    )}
                                                />
                                            </Grid>

                                            {/* <Grid item xs={10} sm={8} md={8} lg={1} xl={1}>
                                                <Tooltip title="Add New Department" arrow className="MuiTooltip-tooltip">
                                                    <IconButton onClick={handleOpenDialog_Department}>
                                                        <Addicon1 sx={{ color: '#298af2' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                            <NewDesignationDialog
                                                open={openDialog_department}
                                                onClose={handleCloseDialog_Department}
                                                onAdd={handleAddDepartment}
                                                onClear={handleClearFormForDesignation}
                                                newDepartment={newDesignation}
                                                handleInputChange={handleInputChangeForDesignation}
                                            /> */}

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={3} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Current Designation <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                                <Autocomplete
                                                    size="small"
                                                    fullWidth
                                                    value={selectedDesignation}
                                                    onChange={(event, newValue) => { setSelectedDesignation(newValue); setDesignationID(newValue.id); }}
                                                    options={designation}
                                                    getOptionLabel={(option) => option.description || ''}
                                                    renderInput={(params) => (
                                                        <TextField color='secondary' {...params} label="" required variant="outlined" error={!!formErrors.designation}
                                                            helperText={formErrors.designation} />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={10} sm={8} md={8} lg={1} xl={1}>
                                                <Tooltip title="Add New Department" arrow className="MuiTooltip-tooltip">
                                                    <IconButton onClick={handleOpenDialog_Department}>
                                                        <Addicon1 sx={{ color: '#298af2' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                            <NewDesignationDialog
                                                open={openDialog_department}
                                                onClose={handleCloseDialog_Department}
                                                onAdd={handleAddDepartment}
                                                onClear={handleClearFormForDesignation}
                                                newDepartment={newDesignation}
                                                handleInputChange={handleInputChangeForDesignation}
                                            />

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Status <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                                <Autocomplete
                                                    size="small"
                                                    fullWidth
                                                    value={selectedEmployeeStatus}
                                                    onChange={(event, newValue) => { setSelectedEmployeeStatus(newValue); setEmployeeStatusID(newValue.id); }}
                                                    options={employeeStatus}
                                                    getOptionLabel={(option) => option.description || ''}
                                                    renderInput={(params) => (
                                                        <TextField  color='secondary' {...params} label="" required variant="outlined" />
                                                    )}
                                                />
                                            </Grid>

                                        </Grid>
                                    </Grid>



                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="30px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Email <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                                <TextField
                                                    value={employeeEmail}
                                                    onChange={(e) => setEmployeeEmail(e.target.value)}
                                                    type="email"
                                                    fullWidth
                                                    size="small"
                                                    label=""
                                                    required
                                                     color='secondary' 
                                                    variant="outlined"

                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Email />
                                                            </InputAdornment>
                                                        ),
                                                    }} error={employeeEmail !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(employeeEmail)}
                                                    helperText={
                                                        employeeEmail !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(employeeEmail)
                                                            ? 'Invalid email format'
                                                            : ''
                                                    } />
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} md={12} lg={12} xl={12}  >
                                        <Grid container padding="12px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Phone
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={2.5} lg={2.5} xl={2.5}>
                                                <TextField  color='secondary' value={employeeWorkPhone} onChange={(e) => setEmployeeWorkPhone(e.target.value)} fullWidth size="small" type="tel" label="Work Phone" variant="outlined"
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <PhoneIcon />
                                                            </InputAdornment>
                                                        ),
                                                    }} error={employeeWorkPhone !== '' && !/^[0-9]{10}$/.test(employeeWorkPhone)}
                                                    helperText={
                                                        employeeWorkPhone !== '' && !/^[0-9]{10}$/.test(employeeWorkPhone)
                                                            ? 'Enter a valid 10-digit phone number'
                                                            : ''} />
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={2.5} lg={2.5} xl={2.5}>
                                                <TextField  color='secondary' value={employeeMobile} onChange={(e) => setEmployeeMobile(e.target.value)} fullWidth size="small" label="Mobile" required variant="outlined"
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <PhoneIphoneIcon />
                                                            </InputAdornment>
                                                        ),
                                                        inputProps: { pattern: "[0-9]*" }
                                                    }}
                                                    error={employeeMobile !== '' && !/^[0-9]{10}$/.test(employeeMobile)}
                                                    helperText={
                                                        employeeMobile !== '' && !/^[0-9]{10}$/.test(employeeMobile)
                                                            ? 'Enter a valid 10-digit phone number'
                                                            : ''}
                                                />
                                            </Grid>




                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} md={12} lg={12} xl={12}  >
                                        <Grid container padding="12px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Emergency Contact
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                                <TextField  color='secondary' value={employeeEmergencyContact} onChange={(e) => setEmployeeEmergencyContact(e.target.value)} fullWidth size="small" label="Mobile" variant="outlined"
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <PhoneIphoneIcon />
                                                            </InputAdornment>
                                                        ),
                                                        inputProps: { pattern: "[0-9]*" }
                                                    }}
                                                    error={employeeEmergencyContact !== '' && !/^[0-9]{10}$/.test(employeeEmergencyContact)}
                                                    helperText={
                                                        employeeEmergencyContact !== '' && !/^[0-9]{10}$/.test(employeeEmergencyContact)
                                                            ? 'Enter a valid 10-digit phone number'
                                                            : ''}
                                                />
                                            </Grid>


                                        </Grid>
                                    </Grid>




                                    {/* <Grid item xs={12} xl={12} >
                                        <Grid container padding="25px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 0, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2.5} lg={9} xl={2} display="flex-start" justifyContent="center">

                                                <Typography variant="h5" fontWeight={'bold'} gutterBottom>
                                                    Hierarchy Information
                                                </Typography>
                                                <Divider sx={{ mb: 2 }} />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12} >
                                        <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    Reporting Manager
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={6.5}>
                                                <Autocomplete
                                                    fullWidth
                                                    value={employee}
                                                    onChange={handleEmployeeChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={employeelist}
                                                    getOptionLabel={(option) => option?.name || ''}

                                                    renderInput={(params) =>
                                                        <TextField required
                                                            placeholder="Select the Reporting Manager"
                                                            {...params} variant="outlined" />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid> */}
                                </Grid>





                                <Grid item xs={6} sm={6} md={6} lg={2} xl={1.5} mt={2} mr="auto">

                                    <Card
                                        style={{ backgroundColor: 'transparent', boxShadow: 'none', width: '220px' }}
                                        sx={{ borderRadius: '50%', textAlign: 'center', margin: 'auto', position: 'relative' }}
                                    >
                                        {image ? (
                                            <>
                                                <CardMedia
                                                    component="img"
                                                    height="200"
                                                    image={image}
                                                    alt="Uploaded image"
                                                    style={{
                                                        borderRadius: '50%',

                                                        objectFit: 'cover',
                                                        width: '200px',
                                                        height: '200px',
                                                        margin: 'auto',
                                                    }}
                                                />
                                                <CardActions
                                                    sx={{
                                                        justifyContent: 'center',
                                                        mt: 1,
                                                        display: 'flex',
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Button size="small" sx={{ color: '#3380bd' }} onClick={handleClick}>
                                                        Change Image
                                                    </Button>
                                                    <IconButton aria-label="delete" onClick={handleImageDelete} >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </CardActions>
                                            </>
                                        ) : (
                                            <div
                                                style={{
                                                    height: '200px',
                                                    width: '200px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    border: '2px dashed #3380bd',
                                                    borderRadius: '50%',
                                                    cursor: 'pointer',
                                                    margin: 'auto',
                                                    color: '#3380bd',
                                                    backgroundColor: 'rgba(51, 128, 189, 0.1)',
                                                    transition: 'background-color 0.3s ease',
                                                }}
                                                onClick={handleClick}
                                                onMouseEnter={e => (e.currentTarget.style.backgroundColor = 'rgba(51, 128, 189, 0.2)')}
                                                onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'rgba(51, 128, 189, 0.1)')}
                                            >
                                                <IconButton sx={{ color: '#3380bd' }}>
                                                    <ImageSearchIcon fontSize="large" />
                                                </IconButton>
                                                <p>Browse Image</p>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            ref={fileInputRef}
                                            onChange={handleImageChange}
                                        />
                                    </Card>
                                </Grid>

                                <Grid>
                                    <Divider sx={{ my: 2, borderColor: '#3380bd' }} />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                        <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                            <Box mt={1}  >

                                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                    <Tabs
                                                        value={value}
                                                        onChange={handleChange}
                                                        indicatorColor="secondary"
                                                        textColor="inherit"
                                                        variant="contained"
                                                        aria-label="full width tabs example"
                                                    >
                                                        <Tab sx={{ textTransform: "none" }} label="Other Details" {...a11yProps(0)} />
                                                        <Tab sx={{ textTransform: "none" }} label="Address" {...a11yProps(1)} />
                                                        <Tab sx={{ textTransform: "none" }} label="Bank Details" {...a11yProps(2)} />
                                                        <Tab sx={{ textTransform: "none" }} label="Skills" {...a11yProps(3)} />
                                                        <Tab sx={{ textTransform: "none" }} label="Accident Records" {...a11yProps(4)} />
                                                        <Tab sx={{ textTransform: "none" }} label="Medical Records" {...a11yProps(5)} />
                                                        <Tab sx={{ textTransform: "none" }} label="Quarters / Vehicle Details" {...a11yProps(6)} />
                                                        <Tab sx={{ textTransform: "none" }} label="Equipment Details" {...a11yProps(7)} />
                                                    </Tabs>
                                                </Box>

                                                <SwipeableViews
                                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                                    index={value}
                                                    onChangeIndex={handleChangeIndex}
                                                >
                                                    <TabPanel value={value} index={0} dir={theme.direction}>
                                                        <Box>
                                                            <Grid container>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                    <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Aadhar Number
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={3.5} lg={3.5} xl={3.5}>
                                                                            <TextField  color='secondary' value={employeeAadhar_Number} onChange={(e) => setEmployeeAdhar_Number(e.target.value)} fullWidth size="small" label="" variant="outlined" />
                                                                        </Grid>

                                                                        <FileUploadWithPreview
                                                                            label="Aadhar Document"
                                                                            onFileChange={handleAadharFileChange}
                                                                            onDownload={() => handleDownload(aadharFileBase64, aadharFileName)}
                                                                        />
                                                                        <Grid item xs={3}>
                                                                            {aadharFileName && <Typography>(Aadhar File: {aadharFileName})</Typography>}
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                PAN
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={3.5} lg={3.5} xl={3.5}>
                                                                            {/*  <TextField value={employeePAN_Number} onChange={(e) => setEmployeePAN_Number(e.target.value)} fullWidth size="small" label="" variant="outlined" /> */}
                                                                            <TextField
                                                                             color='secondary' 
                                                                                value={employeePAN_Number}
                                                                                onChange={(e) => {
                                                                                    const input = e.target.value.toUpperCase();
                                                                                    if (input.length <= 10) {
                                                                                        setEmployeePAN_Number(input);
                                                                                    }
                                                                                }}
                                                                                fullWidth
                                                                                size="small"
                                                                                label="PAN Number"
                                                                                variant="outlined"
                                                                                error={!isPanValid}
                                                                                helperText={!isPanValid ? 'Invalid PAN format (e.g. ABCDE1234F)' : ''}
                                                                            />
                                                                        </Grid>


                                                                        <FileUploadWithPreview
                                                                            label="PAN Document"
                                                                            onFileChange={handlePanFileChange}
                                                                            onDownload={() => handleDownload(panFileBase64, panFileName)}
                                                                        />
                                                                        <Grid item xs={3}>
                                                                            {panFileName && <Typography>(PAN File: {panFileName})</Typography>}
                                                                        </Grid>



                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                UAN
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={3.5} lg={3.5} xl={3.5}>
                                                                            {/* <TextField value={employeeUAN_Number} onChange={(e) => setEmployeeUAN_Number(e.target.value)} fullWidth size="small" label="" variant="outlined" /> */}
                                                                            <TextField
                                                                             color='secondary' 
                                                                                value={employeeUAN_Number}
                                                                                onChange={(e) => {
                                                                                    const input = e.target.value.replace(/[^0-9]/g, ''); // allow only digits
                                                                                    if (input.length <= 12) {
                                                                                        setEmployeeUAN_Number(input);
                                                                                    }
                                                                                }}
                                                                                fullWidth
                                                                                size="small"
                                                                                label="UAN Number"
                                                                                variant="outlined"
                                                                                error={!isUANValid}
                                                                                helperText={!isUANValid ? 'Invalid UAN format (must be 12 digits)' : ''}
                                                                            />

                                                                        </Grid>


                                                                        <FileUploadWithPreview
                                                                            label="UAN Document"
                                                                            onFileChange={handleUANFileChange}
                                                                            onDownload={() => handleDownload(uanFileBase64, uanFileName)}
                                                                        />
                                                                        <Grid item xs={3}>
                                                                            {uanFileName && <Typography>(UAN File: {uanFileName})</Typography>}
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Blood Group
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.5} xl={2.1}>
                                                                            <Autocomplete
                                                                                size="small"
                                                                                fullWidth
                                                                                value={selectedBloodGroup}
                                                                                onChange={(event, newValue) => { setSelectedBloodGroup(newValue); setBloodGroupID(newValue.id); }}
                                                                                options={bloodGroup}
                                                                                getOptionLabel={(option) => option.description || ''}
                                                                                renderInput={(params) => (
                                                                                    <TextField  color='secondary' {...params} label="" required variant="outlined" />
                                                                                )}
                                                                            />
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Marital Status
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={11} md={4} lg={3.5} xl={2.1}>
                                                                            <FormGroup>
                                                                                <FormControlLabel control={<Checkbox size="small" color="secondary" checked={maritalStatus} onChange={(e) => setMaritalStatus(e.target.checked)} />} label="Married" />
                                                                            </FormGroup>
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Is Manager?
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={11} md={4} lg={3.5} xl={2.1}>
                                                                            <FormGroup>
                                                                                <FormControlLabel control={<Checkbox size="small" color="secondary" checked={managerStatus} onChange={(e) => setManagerStatus(e.target.checked)} />} label="Yes" />
                                                                            </FormGroup>
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Job Level
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.5} xl={2.1}>
                                                                            <Autocomplete
                                                                                size="small"
                                                                                fullWidth
                                                                                value={selectedJobLevel}
                                                                                onChange={(event, newValue) => { setSelectedJobLevel(newValue); setJobLevelID(newValue.id); }}
                                                                                options={jobLevel}
                                                                                getOptionLabel={(option) => option.description || ''}
                                                                                renderInput={(params) => (
                                                                                    <TextField  color='secondary' {...params} label="" required variant="outlined" />
                                                                                )}
                                                                            />
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Increment Month
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.5} xl={2.1}>
                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                <Stack spacing={1}>
                                                                                    <DatePicker
                                                                                        views={['year', 'month']} // 👈 key change here
                                                                                        // label="Select Month"
                                                                                        value={dayjs(incrementMonth)}
                                                                                        onChange={(date) => setIncrmentMonth(date)}
                                                                                        format="MMM-YYYY" // 👈 shows only month-year
                                                                                        slotProps={{ textField: { size: 'small', required: true } }}
                                                                                    />
                                                                                </Stack>
                                                                            </LocalizationProvider>
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} xl={12} >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 0, xl: 1 }} alignItems="center" >

                                                                        <Grid item xs={12} sm={12} md={7} lg={12} xl={7} display="flex-start" justifyContent="center">

                                                                            <Typography variant="h6" fontWeight={'bold'} gutterBottom>
                                                                                Hierarchy Information
                                                                            </Typography>
                                                                            <Divider sx={{ mb: 2, }} />

                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} xl={12} >
                                                                    <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                                Reporting Manager
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={4.5}>
                                                                            {/* <Autocomplete
                                                                                fullWidth
                                                                                value={employee}
                                                                                onChange={handleEmployeeChange}
                                                                                size="small"
                                                                                style={{ fontSize: '12px' }}
                                                                                options={employeelist}
                                                                                getOptionLabel={(option) => option?.name || ''}

                                                                                renderInput={(params) =>
                                                                                    <TextField required
                                                                                        placeholder="Select the Reporting Manager"
                                                                                        {...params} variant="outlined" />}
                                                                            /> */}
                                                                            <Autocomplete
                                                                                fullWidth
                                                                                value={employee}
                                                                                onChange={handleEmployeeChange}
                                                                                size="small"
                                                                                style={{ fontSize: '12px' }}
                                                                                options={employeelist || []} // ensures it's always an array
                                                                                getOptionLabel={(option) => option?.name || ''}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                     color='secondary' 
                                                                                        required
                                                                                        placeholder="Select the Reporting Manager"
                                                                                        {...params}
                                                                                        variant="outlined"
                                                                                    />
                                                                                )}
                                                                            />

                                                                        </Grid>


                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} xl={12} >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">

                                                                            </Typography>
                                                                        </Grid>

                                                                        {ReportingManagerDesignation && ReportingManagerJobLevel && (
                                                                            <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>

                                                                                <Typography
                                                                                    variant="subtitle2"
                                                                                    fontSize={15}
                                                                                    color="text.secondary"
                                                                                    sx={{ whiteSpace: 'nowrap' }}
                                                                                >
                                                                                    [ Designation : {ReportingManagerDesignation} , Job Level : {ReportingManagerJobLevel} ]
                                                                                </Typography>
                                                                            </Grid>
                                                                        )}


                                                                    </Grid>

                                                                </Grid>

                                                            </Grid>
                                                        </Box>
                                                    </TabPanel>

                                                    <TabPanel value={value} index={1} dir={theme.direction}>
                                                        <Box>
                                                            <Grid container spacing={1}>
                                                                <Grid item lg={6} xl={6}>
                                                                    <Grid container>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                                                            <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h5" textAlign="left" >
                                                                                        Current Address
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                                                                    {/* <Button variant="contained" sx={{ textTransform: "none", backgroundColor: colors.blueAccent[600] }}> Copy Billing Address</Button> */}
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                        Address
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                                                                    <TextField
                                                                                     color='secondary' 
                                                                                        value={currentAddressLine1}
                                                                                        onChange={(e) => setCurrentAddressLine1(e.target.value)}
                                                                                        fullWidth
                                                                                        id="outlined-multiline-static"
                                                                                        label="Address"
                                                                                        multiline
                                                                                        rows={2}
                                                                                        defaultValue=""
                                                                                    />
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>




                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                                        Country
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                                                                    {/* <Autocomplete
                                                                                        fullWidth
                                                                                        value={selectedCurrentCountry}
                                                                                        onChange={handleCountryChange}
                                                                                        size="small"
                                                                                        options={currentCountry}
                                                                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                                                    /> */}
                                                                                    <Autocomplete
                                                                                        fullWidth
                                                                                        value={currentCountryByHook.selectedCountry}
                                                                                        onChange={handleCountryChange}
                                                                                        size="small"
                                                                                        options={currentCountryByHook.country}
                                                                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                                                                        renderInput={(params) => <TextField color='secondary'  {...params} variant="outlined" />}
                                                                                    />

                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                                        State
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                                                                    {/* <Autocomplete
                                                                                        fullWidth
                                                                                        value={selectedCurrentState}
                                                                                        onChange={handleStateChange}
                                                                                        size="small"
                                                                                        options={currentState}
                                                                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                                                    /> */}

                                                                                    <Autocomplete
                                                                                        fullWidth
                                                                                        value={currentStateByHook.selectedState}
                                                                                        onChange={handleStateChange}
                                                                                        size="small"
                                                                                        options={currentStateByHook.stateList}
                                                                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                                                                        renderInput={(params) => <TextField  color='secondary' {...params} variant="outlined" />}
                                                                                    />

                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                                        City
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                                                                    {/* <Autocomplete
                                                                                        fullWidth
                                                                                        value={selectedCurrentCity}
                                                                                        onChange={handleCityChange}
                                                                                        size="small"
                                                                                        options={currentCity}
                                                                                        getOptionLabel={(option) => `${option.description}`}
                                                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                                                    />*/}

                                                                                    <Autocomplete
                                                                                        fullWidth
                                                                                        value={currentCityByHook.selectedCity}
                                                                                        onChange={handleCityChange}
                                                                                        size="small"
                                                                                        options={currentCityByHook.cityList}
                                                                                        getOptionLabel={(option) => `${option.description}`}
                                                                                        renderInput={(params) => <TextField  color='secondary' {...params} variant="outlined" />}
                                                                                    />
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                        Pin Code
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                                                                    <TextField  color='secondary' value={pincode} fullWidth size="small" label="" variant="outlined" onChange={(e) => setPincode(e.target.value)} />
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                        Phone
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                                                                    <TextField  color='secondary' value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} fullWidth size="small" label="" variant="outlined"
                                                                                        InputProps={{
                                                                                            startAdornment: (
                                                                                                <InputAdornment position="start">
                                                                                                    <PhoneIcon />
                                                                                                </InputAdornment>
                                                                                            ),
                                                                                        }} />
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>


                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item lg={6} xl={6}>
                                                                    <Grid container>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                                <Grid item xs={12} sm={12} md={8} lg={12} xl={8}>
                                                                                    <Typography variant="h5" >
                                                                                        Parmanent Address (<span fontSize='8px' style={{ color: 'lightblue' }}>
                                                                                            <IconButton onClick={handleCopyBillingToShipping} style={{ borderRadius: '0px', marginRight: '0px' }}>
                                                                                                <ArrowDownwardIcon style={{ color: "#1976d2", fontSize: '20px' }} />
                                                                                                <Typography variant="button" fontSize={'14px'} style={{ fontWeight: 'bold', fontStyle: 'italic', textTransform: 'none', color: '#1976d2' }}> Copy Current address</Typography>
                                                                                            </IconButton>
                                                                                        </span>)
                                                                                    </Typography>
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                        Address
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                                                                    <TextField
                                                                                     color='secondary' 
                                                                                        value={parmanentAddressLine1}
                                                                                        onChange={(e) => setPaemanentAddressLine1(e.target.value)}
                                                                                        fullWidth
                                                                                        id="outlined-multiline-static"
                                                                                        label="Address"
                                                                                        multiline
                                                                                        rows={2}
                                                                                        defaultValue=""
                                                                                    />
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>


                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                                        Country
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                                                                    {/*  <Autocomplete
                                                                                        fullWidth
                                                                                        value={selectedParmanentCountry}
                                                                                        onChange={handleBillingCountryChange}
                                                                                        size="small"
                                                                                        options={parmanentCountry}
                                                                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                                                    />*/}

                                                                                    <Autocomplete
                                                                                        fullWidth
                                                                                        value={permenantCountryByHook.selectedCountry}
                                                                                        onChange={handleBillingCountryChange}
                                                                                        size="small"
                                                                                        options={permenantCountryByHook.country}
                                                                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                                                                        renderInput={(params) => <TextField  color='secondary' {...params} variant="outlined" />}
                                                                                    />
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                                        State
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                                                                    {/* <Autocomplete
                                                                                        fullWidth
                                                                                        value={selectedParmanentState}
                                                                                        onChange={handleBillingStateChange}
                                                                                        size="small"
                                                                                        // style={{ width: '180px' }}
                                                                                        options={parmanentState}
                                                                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                                                    />*/}

                                                                                    <Autocomplete
                                                                                        fullWidth
                                                                                        value={permenantStateByHook.selectedState}
                                                                                        onChange={handleBillingStateChange}
                                                                                        size="small"
                                                                                        options={permenantStateByHook.stateList}
                                                                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                                                                        renderInput={(params) => <TextField  color='secondary' {...params} variant="outlined" />}
                                                                                    />


                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                                        City
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                                                                    {/*  <Autocomplete
                                                                                        fullWidth
                                                                                        value={selectedParmanentCity}
                                                                                        onChange={handleBillingCityChange}
                                                                                        size="small"
                                                                                        // style={{ width: '180px' }}
                                                                                        options={parmanentCity}
                                                                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                                                    />*/}

                                                                                    <Autocomplete
                                                                                        fullWidth
                                                                                        value={permenantCityByHook.selectedCity}
                                                                                        onChange={handleBillingCityChange}
                                                                                        size="small"
                                                                                        options={permenantCityByHook.cityList}
                                                                                        getOptionLabel={(option) => `${option.description}`}
                                                                                        renderInput={(params) => <TextField  color='secondary' {...params} variant="outlined" />}
                                                                                    />
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                        Pin Code
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                                                                    <TextField  color='secondary' value={parmanentPincode} onChange={(e) => setParmanentPincode(e.target.value)} fullWidth size="small" label="" variant="outlined" />
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                                                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                        Phone
                                                                                    </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                                                                    <TextField  color='secondary' value={parmanentPhoneNumber} onChange={(e) => setParmanentPhoneNumber(e.target.value)} fullWidth size="small" label="" variant="outlined"
                                                                                        InputProps={{
                                                                                            startAdornment: (
                                                                                                <InputAdornment position="start">
                                                                                                    <PhoneIcon />
                                                                                                </InputAdornment>
                                                                                            ),
                                                                                        }} />
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Grid>



                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </TabPanel>

                                                    <TabPanel value={value} index={2} dir={theme.direction}>
                                                        <Box>
                                                            {bankDetails.map((bankDetail, index) => (
                                                                // <Grid container key={index}>

                                                                //     <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                //         <Typography variant="h6" fontSize={16} textAlign="left" sx={{ marginTop: 2, marginBottom: 1 }}>
                                                                //             Bank {index + 1}
                                                                //         </Typography>
                                                                //     </Grid>

                                                                //     <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                //         <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                                //             <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                //                 <Typography variant="h6" fontSize={14} textAlign="left">
                                                                //                     Account Holder Name
                                                                //                 </Typography>
                                                                //             </Grid>
                                                                //             <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>
                                                                //                 <TextField
                                                                //                     fullWidth
                                                                //                     size="small"
                                                                //                     name="accountHolderName"
                                                                //                     value={bankDetail.accountHolderName}
                                                                //                     onChange={(e) => handleInputChange(index, e)}
                                                                //                     label=""
                                                                //                     variant="outlined"
                                                                //                 />
                                                                //             </Grid>
                                                                //         </Grid>
                                                                //     </Grid>

                                                                //     <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                //         <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                                //             <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                //                 <Typography variant="h6" fontSize={14} textAlign="left">
                                                                //                     IFSC
                                                                //                 </Typography>
                                                                //             </Grid>
                                                                //             <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>
                                                                //                 <TextField
                                                                //                     fullWidth
                                                                //                     size="small"
                                                                //                     name="ifsc"
                                                                //                     value={bankDetail.ifsc}
                                                                //                     onChange={(e) => handleInputChange(index, e)}
                                                                //                     label=""
                                                                //                     variant="outlined"
                                                                //                 />
                                                                //             </Grid>
                                                                //         </Grid>
                                                                //     </Grid>

                                                                //     <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                //         <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                                //             <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                //                 <Typography variant="h6" fontSize={14} textAlign="left">
                                                                //                     Bank Name
                                                                //                 </Typography>
                                                                //             </Grid>
                                                                //             <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>
                                                                //                 <TextField
                                                                //                     fullWidth
                                                                //                     size="small"
                                                                //                     name="bankName"
                                                                //                     value={bankDetail.bankName}
                                                                //                     onChange={(e) => handleInputChange(index, e)}
                                                                //                     label=""
                                                                //                     variant="outlined"
                                                                //                 />
                                                                //             </Grid>
                                                                //         </Grid>
                                                                //     </Grid>

                                                                //     <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                //         <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                                //             <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                //                 <Typography variant="h6" fontSize={14} textAlign="left" required>
                                                                //                     Account Number
                                                                //                 </Typography>
                                                                //             </Grid>
                                                                //             <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>
                                                                //                 <TextField
                                                                //                     fullWidth
                                                                //                     size="small"
                                                                //                     name="accountNumber"
                                                                //                     value={bankDetail.accountNumber}
                                                                //                     onChange={(e) => handleInputChange(index, e)}
                                                                //                     InputProps={{
                                                                //                         endAdornment: (
                                                                //                             <InputAdornment position="start">
                                                                //                                 <VisibilityOffIcon />
                                                                //                             </InputAdornment>
                                                                //                         ),
                                                                //                     }}
                                                                //                     label=""
                                                                //                     variant="outlined"
                                                                //                 />
                                                                //             </Grid>
                                                                //         </Grid>
                                                                //     </Grid>

                                                                //     <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                //         <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                                //             <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                //                 <Typography variant="h6" fontSize={14} textAlign="left">
                                                                //                     Re-enter Account Number
                                                                //                 </Typography>
                                                                //             </Grid>
                                                                //             <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>
                                                                //                 <TextField
                                                                //                     fullWidth
                                                                //                     size="small"
                                                                //                     name="reEnterAccountNumber"
                                                                //                     value={bankDetail.reEnterAccountNumber}
                                                                //                     onChange={(e) => handleInputChange(index, e)}
                                                                //                     label=""
                                                                //                     variant="outlined"
                                                                //                 />
                                                                //             </Grid>
                                                                //             {index > 0 && (
                                                                //                 <Grid item xs={12} sm={1} md={1} lg={1} xl={1}>
                                                                //                     <IconButton onClick={() => removeBankDetail(index)} color="secondary">
                                                                //                         <DeleteIcon />
                                                                //                     </IconButton>
                                                                //                 </Grid>
                                                                //             )}
                                                                //         </Grid>

                                                                //     </Grid>

                                                                //     <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                                                //         <Divider />
                                                                //     </Grid>
                                                                // </Grid>

                                                                <BankDetailsForm
                                                                    key={index}
                                                                    index={index}
                                                                    bankDetail={bankDetail}
                                                                    bankAccounts={bankAccounts}
                                                                    showPassword={showPassword}
                                                                    accountMismatch={accountMismatch}
                                                                    handleInputChange={handleInputChange}
                                                                    handleAutocompleteChange={handleAutocompleteChange}
                                                                    handleClickShowPassword={handleClickShowPassword}
                                                                    handleMouseDownPassword={handleMouseDownPassword}
                                                                    handleBankLetterInputChange={handleBankLetterInputChange}
                                                                    handleDownloadBankLetter={handleDownloadBankLetter}
                                                                    removeBankDetail={removeBankDetail}
                                                                    handleChequeInputChange={handleChequeInputChange}
                                                                    handleRTGSInputChange={handleRTGSInputChange}
                                                                    setAccountMismatch={setAccountMismatch}
                                                                    handleOpenModal={handleOpenModal}
                                                                />
                                                            ))}

                                                            <Button
                                                                size='small'
                                                                sx={{ marginTop: "10px", textTransform: "none" }}
                                                                onClick={addBankDetail}
                                                                variant="standard"
                                                                color="primary"
                                                                startIcon={<AddIcon />}
                                                            >
                                                                Add Bank Detail
                                                            </Button>
                                                        </Box>
                                                    </TabPanel>

                                                    <TabPanel value={value} index={3} dir={theme.direction}>
                                                        <Box>

                                                            <SkillTable
                                                                dataSkillDetails={dataSkillDetails} // ✅ match child prop name
                                                                setDataSkillDetails={setDataSkillDetails} // ✅ match child prop name
                                                                idEmployee={selectemployeeid}
                                                            />

                                                        </Box>
                                                    </TabPanel>

                                                    <TabPanel value={value} index={4} dir={theme.direction}>
                                                        <Box>
                                                            <EmployeeAccidentSection
                                                                accidentDetails={accidentDetails}
                                                                setAccidentDetails={setAccidentDetails}
                                                            />
                                                        </Box>
                                                    </TabPanel>


                                                    <TabPanel value={value} index={5} dir={theme.direction}>
                                                        <Box>
                                                            <EmployeeMedicalConditionSection
                                                                medicalConditions={medicalConditions}
                                                                setMedicalConditions={setMedicalConditions}
                                                            />
                                                        </Box>
                                                    </TabPanel>

                                                    <TabPanel value={value} index={6} dir={theme.direction}>
                                                        <Box>
                                                            <Grid container>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                    <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Quarters Number
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={3.5} lg={3.4} xl={2.1}>
                                                                            <TextField
                                                                             color='secondary' 
                                                                                fullWidth
                                                                                value={formData.quartersNumber || ''}
                                                                                onChange={(e) =>
                                                                                    setFormData({ ...formData, quartersNumber: e.target.value })
                                                                                } size="small" variant="outlined" />
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Facilities Available
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={3.5} lg={3.4} xl={2.1}>
                                                                            <Autocomplete
                                                                                multiple
                                                                                options={['Fan', 'AC', 'Geyser', 'TV', 'Fridge']}
                                                                                value={formData.facilitiesAvailable || []}
                                                                                onChange={(e, newVal) =>
                                                                                    setFormData({ ...formData, facilitiesAvailable: newVal })
                                                                                }
                                                                                renderInput={(params) => (
                                                                                    <TextField  color='secondary' {...params} size="small" />
                                                                                )}
                                                                            />
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Vehicle Type
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={3.5} lg={3.4} xl={2.1}>
                                                                            <FormControl fullWidth>
                                                                                {/* <InputLabel>Vehicle Type</InputLabel> */}
                                                                                <Select
                                                                                    size="small"
                                                                                    value={formData.vehicleType || ''}
                                                                                    onChange={(e) =>
                                                                                        setFormData({ ...formData, vehicleType: e.target.value })
                                                                                    }
                                                                                >
                                                                                    <MenuItem value="Car">Car</MenuItem>
                                                                                    <MenuItem value="Two-Wheeler">Two-Wheeler</MenuItem>
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>


                                                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                                                            <Typography variant="h6" fontSize={14} textAlign="left" >
                                                                                Facility Type
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={12} md={3.5} lg={3.4} xl={2.1}>

                                                                            <FormControl fullWidth>
                                                                                <Select
                                                                                    size="small"
                                                                                    value={formData.facilityType || ''}
                                                                                    onChange={(e) =>
                                                                                        setFormData({ ...formData, facilityType: e.target.value })
                                                                                    }                                                                               >
                                                                                    <MenuItem value="Petrol allowance only">Petrol allowance only</MenuItem>
                                                                                    <MenuItem value="Car only">Car only</MenuItem>
                                                                                    <MenuItem value="Car with driver">Car with driver</MenuItem>
                                                                                    <MenuItem value="Company-provided car budget">
                                                                                        Company-provided amount to purchase a new car
                                                                                    </MenuItem>
                                                                                    <MenuItem value="Other">Other</MenuItem>
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>


                                                                        {/* RC Upload */}
                                                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3}>
                                                                            <Typography variant="h6" fontSize={14}>RC Upload</Typography>
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={12} md={3.5} lg={3.4} xl={2.1}>
                                                                            <Button variant="contained" component="label" size="small">
                                                                                Upload
                                                                                <input
                                                                                    type="file"
                                                                                    hidden
                                                                                    onChange={(e) => {
                                                                                        const file = e.target.files[0];
                                                                                        const reader = new FileReader();
                                                                                        reader.onloadend = () => {
                                                                                            setFormData({ ...formData, rcFile: reader.result, rcFileName: file.name });
                                                                                        };
                                                                                        if (file) reader.readAsDataURL(file);
                                                                                    }}
                                                                                />
                                                                            </Button>
                                                                            {formData.rcFileName && (
                                                                                <Typography variant="caption" sx={{ mt: 1 }}>{formData.rcFileName}</Typography>
                                                                            )}
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                            </Grid>





                                                        </Box>
                                                    </TabPanel>

                                                    <TabPanel value={value} index={7} dir={theme.direction}>
                                                        <Box>
                                                            <EmployeeEquipmentForm equipmentList={equipmentList} setEquipmentList={setEquipmentList} />
                                                        </Box>
                                                    </TabPanel>


                                                </SwipeableViews>
                                            </Box>

                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>

                        </Box>



                        {/* <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Box position="fixed" sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>

                                    <Toolbar>
                                        <Button type="submit" disabled={saveButtonDisabled} size="small" variant="contained" color="secondary" startIcon={<Save />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save</Button>
                                        <Button size="small" variant="standard" startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
                                    </Toolbar>
                                </Box>
                            </Grid>
                        </Grid> */}


                    </form>
                </>)}
            {exitEmployee && (
                <>
                    <ExitEmployee handlecallback={CallBackExitEmployee} editEmployeeID={editPartyID} employee_code={employeeNumber} dateOfJoinning={dateOfJoinning} />
                </>
            )}

            {employeeCompansation && (
                <>
                    <EmployeeCompensation handlecallback={CallBackExitEmployee} editEmployeeID={editPartyID} employee_code={employeeNumber} />
                </>
            )}
        </Box>

    </>)
}
export default AddNewEmployee;